import post_req from '../funzioni_server/richiesta_generale.js'
import { setPagina,getPagina,setToken,setUserId,removeToken,removeUserId,setSidebar,setRuolo,getRuolo,setLingua,getLingua } from "../auth";
import { criptaRuolo,decriptaRuolo, } from "../funzioni/funzioni_utili";
const login = async ({username=undefined, password=undefined}) => {
        var dati={}
        dati["action"]='Login'
        dati['user']=username
        dati['pwd']=password
        const response = await post_req({"request":dati})

        if (response.status===0 ) {
    setToken(response.token);  // Salva il token
    setUserId(response.userid);// Salva l'ID utente
    const paginaAttuale=parseInt(getPagina())||0
    setRuolo(criptaRuolo(response.type,"scuolaKitesurfKenya"))
    if (!getLingua())setLingua(1)
    setSidebar(true)

    if (response.type===0||response.type===1){
    if (paginaAttuale===0){
    window.location.href = "/plan";}
    else{window.location.href = "/bookingsvilla" }

    }

    else {window.location.href = "/agendainstructor";}
} else {
    alert("Credenziali errate!");
}
return response

};
export default login